
  <div class="content">
    <h1 class="title">通关成功</h1>
    <p class="tips">暂时跻身前500名</p>
    <p class="tips" style="margin-top: 0.1rem">请选择您的心愿景点</p>
    <RadioGroup v-model="checked" class="reward-wrap" checked-color="#B9352B">
      <div
        v-for="(item, index) in rewardsList"
        :key="item.value"
        class="reward"
      >
        <Radio :name="index">
          <img :src="item.url" alt="" />
          <div class="reward-info">
            <p class="reward-name">
              {{ item.name }}
            </p>
            <p class="reward-tips">{{ item.tips }}</p>
          </div>
        </Radio>
      </div>
    </RadioGroup>
    <Button @click="handleSelect" class="submit-btn">提交心愿</Button>
  </div>
